import React from "react";
import { ArrowRight } from "lucide-react";
import { useContactModal } from "../context/ContactModalContext";

const CTA_CARD_BG = "#121313";
const BTN_CLASS_DARK =
  "mt-4 inline-flex w-fit items-center gap-2 rounded-full border-2 border-white bg-transparent px-6 py-3 text-sm font-semibold tracking-wide text-white transition-colors hover:bg-white hover:text-[#121313]";

/**
 * Reusable highlighted contact section (two-column: KONTAKT label + dark green card).
 * Card uses same border radius as buttons (rounded-2xl).
 */
export default function HighlightedContactSection({
  heading,
  description,
  buttonText = "Jetzt Kontakt aufnehmen",
  sectionId = "section-contact",
}) {
  const { openContactModal } = useContactModal() || {};

  return (
    <section id={sectionId} className="border-b border-gray-100 py-10 md:py-12">
      <div className="container-app mx-auto flex flex-col gap-6 px-4 md:flex-row md:gap-10 lg:gap-12">
        <div className="flex-shrink-0 md:w-36 lg:w-40">
          <span className="detail-side-label text-xs font-semibold uppercase tracking-[0.2em] text-gray-700">
            KONTAKT
          </span>
        </div>
        <div className="min-w-0 flex-1 max-w-4xl">
          <div
            className="rounded-2xl p-6 shadow-[0_2px_12px_rgba(0,0,0,0.08)] md:p-8"
            style={{ backgroundColor: CTA_CARD_BG }}
          >
            {heading && (
              <h2 className="text-xl font-semibold text-white md:text-2xl">
                {heading}
              </h2>
            )}
            {description && (
              <p className="mt-2 text-sm text-white/90 md:text-base">
                {description}
              </p>
            )}
            <button
              type="button"
              onClick={() => openContactModal?.()}
              className={"group " + (heading || description ? BTN_CLASS_DARK : "mt-6 " + BTN_CLASS_DARK)}
            >
              {buttonText}
              <ArrowRight className="h-5 w-6 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-0.5" aria-hidden />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
